import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=951bd94a&scoped=true"
import script from "./addAndEdit.vue?vue&type=script&lang=js"
export * from "./addAndEdit.vue?vue&type=script&lang=js"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&id=951bd94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951bd94a",
  null
  
)

export default component.exports